import Joi from 'joi'

import { validator } from 'utils'

const role = Joi.object({
  name: validator.getRuleString('ชื่อบริษัท'),
}).options({ allowUnknown: true })

export default role
